import { Avatar, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, Pagination, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@mui/material"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import Dropdown from "../../reusable_components/components/Dropdown"
import { useContext, useEffect, useState } from "react"
import { useGetEventDropDownQuery, useUpdateJobManageEventsMutation } from "../../redux/jobpostings/jobManageEvents.api"
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import { useDeleteEventHistoryMutation, useEventsHistoryMutation, useMatchProfileListMutation } from "../../redux/jobpostings/jobpostings.api"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import DeleteIcon from "../../assets/Icons/DeleteIcon"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import Loader from "../../reusable_components/components/Loader"
import { TableLoader } from '../../reusable_components/components/TableLoader';



const DashboardManageEvents = () => {

    const location = useLocation()
    const navigate = useNavigate()
    const { positionId, eventTypeId, clientName, positionTitle } = location?.state || ""
    const { Profile } = useSelector((state) => state.common)
    const { Snackbar } = useContext(SnackbarContext)

    const params = useParams()
    const eventId = params?.eventTypeId

    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalPageCount, setTotalPageCount] = useState(0)
    const [eventsTableListDatas, setEventsTableListDatas] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(eventId)
    const [open, setOpen] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [historyRowData, setHistoryRowData] = useState({})
    const [profileId, setProfileId] = useState("")
    const [historyTableDatas, setHistoryTableDatas] = useState([])
    const [changedRows, setChangedRows] = useState([])
    const [showLoader, setShowLoader] = useState(false)
    const [showTableLoader, setShowTableLoader] = useState(false)


    const handleOpen = (item) => {
        setOpen(true)
        setProfileId(item?.profileId)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleOpenDelete = (item) => {
        setOpenDelete(true)
        setHistoryRowData(item)
    }

    const handleCloseDelete = () => {
        setOpenDelete(false)
    }

    const [matchProfileList] = useMatchProfileListMutation()
    const { data: eventDropDown } = useGetEventDropDownQuery()
    const [eventHistory] = useEventsHistoryMutation()
    const [deleteEventHistory] = useDeleteEventHistoryMutation()
    const [updateEvents, { data: updatedEvents }] = useUpdateJobManageEventsMutation()

    const handlePageChange = (e, newValue) => {
        setPage(newValue)
    }

    const handleRowsPerpageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10))
        setPage(0)
    }

    const handleEventChange = (value) => {
        setSelectedEvent(value)
    }



    useEffect(() => {
        const getTableDatas = async () => {
            try {
                const payload = {
                    eventTypeId: +selectedEvent || 0,
                    positionId: positionId,
                    page: 0,
                    size: 10000,
                    profileKeyword: ""
                }
                setShowTableLoader(true)
                const response = await matchProfileList(payload).unwrap()
                setShowTableLoader(false)
                if (response?.status === 200) {
                    setEventsTableListDatas(response?.response?.data || [])
                    setTotalPageCount(response?.response?.totalCount)
                }
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getTableDatas()
    }, [rowsPerPage, selectedEvent, updatedEvents, eventTypeId])

    const handleTableEventChange = (value, slicedIndex) => {
        const actualIndex = (page - 1) * rowsPerPage + slicedIndex

        const updatedEvent = [...eventsTableListDatas]
        updatedEvent[actualIndex] = {
            ...updatedEvent[actualIndex],
            eventTypeId: value
        }
        setEventsTableListDatas(updatedEvent)

        const ProfileMatchIdId = eventsTableListDatas[actualIndex]?.profileMatchId
        if (!changedRows?.includes(ProfileMatchIdId)) {
            setChangedRows((prev) => [...prev, ProfileMatchIdId])
        }
    }

    const handleRemarksChange = (e, slicedIndex) => {
        const value = e.target.value
        const actualIndex = (page - 1) * rowsPerPage + slicedIndex;

        const updatedRemarks = [...eventsTableListDatas]
        updatedRemarks[actualIndex] = {
            ...updatedRemarks[actualIndex],
            remarks: value
        }
        setEventsTableListDatas(updatedRemarks)

        const ProfileMatchIdId = eventsTableListDatas[actualIndex]?.profileMatchId
        if (!changedRows?.includes(ProfileMatchIdId)) {
            setChangedRows((prev) => [...prev, ProfileMatchIdId])
        }
    }

    useEffect(() => {
        const getHistoryTableDatas = async () => {
            try {
                const payload = {
                    page: 0,
                    positionId: positionId,
                    profileId: profileId,
                    size: 5000
                }
                if (open) {
                    const response = await eventHistory(payload).unwrap()
                    if (response?.status === 200) {
                        setHistoryTableDatas(response?.response?.eventHistory)
                    }
                }
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getHistoryTableDatas()
    }, [open])

    const handleEventsHistoryDelete = async () => {
        try {
            const payload = {
                eventHistoryIds: [historyRowData?.eventHistoryId],
                profileMatchId: historyRowData?.profileMatchId
            }

            const response = await deleteEventHistory(payload).unwrap()
            if (response?.status === 200) {
                Snackbar("The History deleted successfully", 'success')
                handleClose()
                handleCloseDelete()
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    const handleSaveHIstory = async () => {
        try {
            const modifiedItems = eventsTableListDatas?.filter((item) =>
                changedRows?.includes(item?.profileMatchId)
            );

            const payload = {
                values: modifiedItems?.map((item) => ({
                    comment: item?.remarks || null,
                    eventTypeId: item?.eventTypeId,
                    profileMatchId: item?.profileMatchId
                }))
            };

            setShowLoader(true)
            const response = await updateEvents(payload).unwrap()
            setShowLoader(false)

            if (response?.status === 200) {
                Snackbar('The event has been updated successfully', 'success')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
            setShowLoader(false)
        }
    }

    return (
        <Box className='container'>
            {showLoader ? <Loader /> : ""}
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px' }} onClick={() => navigate('/dashboard')}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <Grid2 sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                <Typography className="title" sx={{ display: 'flex', alignItems: 'flex-start' }}> Manage Job Stages </Typography>
                <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '16px' }}>{positionTitle}<br />
                    <span style={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>{positionId} - {clientName}</span></Typography>
            </Grid2>
            <Grid2 container sx={{ marginTop: '25px' }}>
                <Grid2 item container sx={{ flexGrow: 1 }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <Grid2 item sx={{ width: '20%' }}>
                                            <Dropdown
                                                value={selectedEvent || ""}
                                                onChange={handleEventChange}
                                                options={eventDropDown?.response || []}
                                                placeholder='Select an Event'
                                                valueKey='eventTypeId'
                                                labelKey='event'
                                                sx={{ borderRadius: '7px', color: '#414651' }}
                                            />
                                        </Grid2>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="tableHeadersCell">Name</TableCell>
                                    <TableCell className="tableHeadersCell">Select Event</TableCell>
                                    <TableCell className="tableHeadersCell">Remarks</TableCell>
                                    <TableCell className="tableHeadersCell">Action</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                !showTableLoader ? (
                                    eventsTableListDatas?.length > 0 ? (
                                        <TableBody>
                                            {eventsTableListDatas?.slice((page - 1) * rowsPerPage, page * rowsPerPage)?.map(
                                                (item, index) => {
                                                    const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink'];
                                                    let firstLetter = item?.firstName
                                                    const letter = firstLetter?.charAt(0)?.toUpperCase()
                                                    const backgroundColor = colors[index % colors?.length]
                                                    return (
                                                        <TableRow
                                                            key={index}
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}
                                                        >
                                                            <TableCell className="tableBodyCell">
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '13px', marginTop: '-13px' }}>
                                                                    <Avatar sx={{ backgroundColor: backgroundColor }}>{letter}</Avatar>
                                                                    <div>
                                                                        <span style={{ color: '#53389E', fontWeight: 550 }}> {item?.firstName} {item?.lastName} </span> <br /><p style={{ color: '#535862' }}>{item?.email} <br /> {item?.mobileNumber}</p>
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="tableBodyCell" sx={{ width: '25%' }}>
                                                                <Dropdown
                                                                    placeholder='Select an Event'
                                                                    sx={{ width: '90%', fontSize: '13px', borderRadius: '7px', marginBottom: '25px', color: '#414651' }}
                                                                    value={item?.eventTypeId || ''}
                                                                    onChange={(value) => handleTableEventChange(value, index)}
                                                                    options={eventDropDown?.response || []}
                                                                    valueKey='eventTypeId'
                                                                    labelKey='event'
                                                                />
                                                            </TableCell>
                                                            <TableCell className="tableBodyCell" sx={{ width: '40%' }}>
                                                                <textarea
                                                                    className="jobPostingTextAreas"
                                                                    placeholder="Enter a description..."
                                                                    style={{ width: '90%', resize: 'none', borderRadius: '7px', color: '#535862' }}
                                                                    value={item?.remarks || ''}
                                                                    onChange={(e) => handleRemarksChange(e, index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell className="tableBodyCell">
                                                                <IconButton sx={{ color: '#6941C6', fontSize: '12.5px', marginBottom: '30px', fontWeight: 600 }} onClick={() => handleOpen(item)}>
                                                                    View History
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                            {Math.ceil(totalPageCount / rowsPerPage) > 1 && (
                                                <TableRow>
                                                    <TableCell colSpan={100}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <MUICancelButton
                                                                title='Previous'
                                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                                sx={{ height: '36px' }}
                                                                onClick={() => handlePageChange(null, page - 1)}
                                                                disabled={page === 1}
                                                            />

                                                            <Pagination
                                                                page={page}
                                                                count={Math.ceil(totalPageCount / rowsPerPage)}
                                                                onChange={handlePageChange}
                                                                siblingCount={1}
                                                                boundaryCount={1}
                                                                shape="rounded"
                                                                hidePrevButton
                                                                hideNextButton
                                                            />

                                                            <MUICancelButton
                                                                title='Previous'
                                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalPageCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                                sx={{ height: '36px' }}
                                                                onClick={() => handlePageChange(null, page + 1)}
                                                                disabled={page === Math.ceil(totalPageCount / rowsPerPage)}
                                                            />
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={13}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </Table>
                    </Paper>

                    {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerpageChange}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    count={totalPageCount || 0}
                                    className="tablepagination"
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> */}
                </Grid2>

                <Grid2 item>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth='md'
                        scroll="paper"
                        sx={{
                            "& .MuiDialog-paper": {
                                minHeight: '80vh',
                                minWidth: '70vw'
                            },
                            marginLeft: '70px'
                        }}
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 600 }}>
                            History
                            <CloseIcon sx={{ color: '#52525B', cursor: 'pointer' }} onClick={handleClose} />
                        </DialogTitle>
                        <DialogContent dividers>
                            <DialogContentText>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="tableHeadersCell">Date</TableCell>
                                            <TableCell className="tableHeadersCell">Client Name</TableCell>
                                            <TableCell className="tableHeadersCell">Job Title</TableCell>
                                            <TableCell className="tableHeadersCell">Event</TableCell>
                                            <TableCell className="tableHeadersCell">Notes</TableCell>
                                            <TableCell className="tableHeadersCell">Processed By</TableCell>
                                            <TableCell className="tableHeadersCell">Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {historyTableDatas?.length > 0 ? (
                                        <TableBody>
                                            {historyTableDatas?.map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}
                                                >
                                                    <TableCell className="tableBodyCell">{item?.date ? dayjs(item?.date).format('DD/MM/YYYY hh:mm:ss A') : "NA"}</TableCell>
                                                    <TableCell className="tableBodyCell">{item?.clientName}</TableCell>
                                                    <TableCell className="tableBodyCell">{item?.jobTitile}</TableCell>
                                                    <TableCell className="tableBodyCell">{item?.event}</TableCell>
                                                    <TableCell className="tableBodyCell">{item?.notes ? item?.notes : "NA"}</TableCell>
                                                    <TableCell className="tableBodyCell">{item?.processedBy}</TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        <IconButton sx={{ color: item?.deletable && '#fd5c63' }} disabled={!item?.deletable} onClick={() => handleOpenDelete(item)}>
                                                            <DeleteIcon stroke={item?.deletable ? 'red' : '#a2a2a2'} style={{ cursor: !item?.deletable && 'not-allowed', pointerEvents: 'auto' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )}
                                </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <MUICancelButton title='close' onClick={handleClose} sx={{ borderColor: '#D6BBFB' }} />
                        </DialogActions>
                    </Dialog>
                </Grid2>
            </Grid2>

            <Grid2 item>
                <Dialog
                    open={openDelete}
                    onClose={handleCloseDelete}
                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '40vw',
                            minHeight: '20vh',
                            borderRadius: '15px'
                        },
                    }}
                >
                    <DialogContent>
                        <DialogContentText>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>
                                <div style={{ backgroundColor: '#FEE4E2', borderRadius: '40px', height: '40px', width: '45px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <DeleteIcon stroke={'red'} />
                                </div>

                                <div>
                                    <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Delete Job?</Typography>
                                    <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                        Are you sure you want to delete this post? This action cannot be undone.
                                    </Typography>
                                </div>
                            </div>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='Cancel' onClick={handleCloseDelete} />
                                <MUIButton title='Delete' sx={{ backgroundColor: '#D92D20', borderRadius: '10px', }} onClick={handleEventsHistoryDelete} />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2>
            {
                eventsTableListDatas?.length > 0 ? (
                    <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: '20px', marginTop: '20px' }}>
                        <MUICancelButton title='Cancel' component={Link} to={`/dashboard`} />
                        {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                            <MUIButton title='Save Changes' onClick={handleSaveHIstory} sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '120px' }} />
                        )}
                    </Grid2>
                ) : (<></>)
            }

        </Box>
    )
}

export default DashboardManageEvents